import styled from 'styled-components';

import { brandFont } from 'styles/brand-font';
import { primitive } from 'styles/constants/primitives';

import { CONTAINER_SPACING_TOP, CONTAINER_SPACING_TOP_DESKTOP } from './constants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-block-start: ${CONTAINER_SPACING_TOP};
  ${Styles.desktop} {
    margin-block-start: ${CONTAINER_SPACING_TOP_DESKTOP};
    margin-block-end: ${primitive.$spacing7};
  }
`;
export const Title = styled.h1`
  font: ${brandFont.headerOne};
  text-transform: capitalize;
  margin: 0;
`;
export const Text = styled.p`
  margin: 0;
  font: ${brandFont.copyOne};
  text-align: center;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-block-start: ${primitive.$spacing4};
  width: 80%;
  ${Styles.desktop} {
    width: 300px;
  }
`;
export const ButtonLabel = styled.p`
  text-transform: capitalize;
  margin: 0;
`;
